import type { Validator } from "redux-form";

export const combineReduxFormValidationRules = (
  ...validators: Array<Validator | Validator[] | boolean | undefined>
): Validator[] => {
  return validators.flat().filter((validator) => {
    return typeof validator === "function";
  }) as Validator[];
};
